export default __webpack_public_path__ + "static/media/support-notes-main-mundo-ejecutivo.374bc5ce.png";